<template>
  <div :class="['row', justifyContent]">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'GridRowCmp',
  props: {
    dataJustifyContent: {
      type: String,
      default: null,
      validator: (value) => ['start', 'center', 'end', 'around', 'between', 'evenly'].includes(value)
    }
  },
  computed: {
    justifyContent() {
      return this.dataJustifyContent
        ? `justify-content-${this.dataJustifyContent}`
        : undefined;
    }
  }
};
</script>